var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailOpenDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.43555 19V10.0704C3.43555 9.40165 3.76975 8.77718 4.32615 8.40625L11.3261 3.73959C11.9979 3.29172 12.8731 3.29172 13.5449 3.73959L20.5449 8.40625C21.1013 8.77718 21.4355 9.40165 21.4355 10.0704V19M3.43555 19C3.43555 20.1046 4.33098 21 5.43555 21H19.4355C20.5401 21 21.4355 20.1046 21.4355 19M3.43555 19L10.1855 14.5M21.4355 19L14.6855 14.5M3.43555 9.99999L10.1855 14.5M21.4355 9.99999L14.6855 14.5M14.6855 14.5L13.5449 15.2604C12.8731 15.7083 11.9979 15.7083 11.3261 15.2604L10.1855 14.5",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenDark);
export default __webpack_public_path__ + "static/media/MailOpenDark.d96d6096c88bd7fa7fc1ac1505b65922.svg";
export { ForwardRef as ReactComponent };